/**
 * Where to come back to after logging in. `to` is a locale-free path on this site
 * (e.g. "/dogodki/123"); the login page pushes it through the next-intl router,
 * which adds the locale.
 */
export const loginHref = (to: string) => `/login?to=${encodeURIComponent(to)}`;

/**
 * A `?to=` value that is safe to navigate to: a path on this site only. Anything
 * protocol-relative ("//host", "/\host"), absolute, or with control characters is
 * refused (null), so the login page can't be used as an open redirect.
 */
export function safeRedirectPath(to: string | null | undefined): string | null {
  if (!to || !to.startsWith("/")) return null;
  if (to.startsWith("//") || to.startsWith("/\\")) return null;
  if (/[\u0000-\u001f\u007f]/.test(to)) return null;
  return to;
}
